// extracted by mini-css-extract-plugin
module.exports = {"icon_seat_link":"partnerBatchBookingDetail_icon_seat_link__Saitk","icon-seat-espace":"partnerBatchBookingDetail_icon-seat-espace__3tQbr"};